import React, { HTMLAttributes } from 'react';
import styled from 'styled-components/macro';

type Props = {
  spacing?: number
};

export function Row({ spacing = 0, ...props }: Props & HTMLAttributes<HTMLDivElement>) {
  return (
    <StyledRow spacing={spacing} {...props}/>
  );
}

const StyledRow = styled.div<{ spacing: number }>`
  display: flex;
  flex-wrap: wrap;
  margin: -${(props) => props.spacing / 2}rem;
  > * {
    padding: ${(props) => props.spacing / 2}rem;
  }
`;
